import { createListenerMiddleware, type TypedStartListening } from "@reduxjs/toolkit";
import type { RootStoreState } from "@store/types";

export const listenerMiddleware = createListenerMiddleware();
export type AppStartListening = TypedStartListening<RootStoreState>;
export const startListening = listenerMiddleware.startListening as AppStartListening;
